/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { Fragment } from "react";
import DisplayTextOnly from "cms/fields/layout/controls/display-text-only";
import { useCurrentDynamicField } from "cms/fields/hooks/use-current-dynamic-field";
import { FieldDisplayWrapper } from "cms/fields/layout/field-display-wrapper";
import { isArrayNotEmpty } from "utils/empty-exists";

const BooleanFieldDisplay = () => {
    
    const { field } = useCurrentDynamicField();
    const values = field?.values;

    return (
        <FieldDisplayWrapper>
            {isArrayNotEmpty(values) &&
                values.map((item, index) => {
                    const { value, settings } = item || {};
                    const { style, options } = settings || {};
                    const { labelText } = options || {};
                    
                    return (
                        <Fragment key={index}>
                            {(value && labelText) &&
                                <DisplayTextOnly
                                    value={labelText}
                                    style={style}
                                />
                            }
                        </Fragment>
                    );
                })
            }
        </FieldDisplayWrapper>
    );
};
BooleanFieldDisplay.displayName = "BooleanFieldDisplay";
export { BooleanFieldDisplay };
